import * as React from 'react';
import { Box, Stack } from '@mui/material';
import { Helmet } from 'react-helmet-async';

import type { Metadata } from '@/types/v2/metadata';

interface LayoutContainerProps {
  children: React.ReactNode;
  metadata: Metadata;
}
export function LayoutContainer({ children, metadata }: LayoutContainerProps): React.JSX.Element {
  return (
    <React.Fragment>
      <Helmet>
        <title>{metadata.title}</title>
      </Helmet>
      <Box
        sx={{
          maxWidth: 'var(--Content-maxWidth)',
          m: 'var(--Content-margin)',
          p: 'var(--Content-padding)',
          width: 'var(--Content-width)',
        }}
      >
        <Stack spacing={4}>{children}</Stack>
      </Box>
    </React.Fragment>
  );
}
